<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
    :class="isAbsolute ? 'mt-4' : 'mt-0'"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :color="color" />
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="d-flex align-items-center ms-auto"
          :class="isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <ul class="navbar-nav d-flex flex-row align-items-center">
            <!-- Mobile Menu Toggle -->
            <li class="nav-item d-xl-none pe-3 d-flex align-items-center">
              <a
                href="#"
                @click="toggleSidebar"
                class="p-0 nav-link text-body lh-1"
                id="iconNavbarSidenav"
              >
                <div class="sidenav-toggler-inner">
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                  <i class="sidenav-toggler-line"></i>
                </div>
              </a>
            </li>

            <!-- Settings Icon -->
            <li class="nav-item px-3 d-flex align-items-center">
              <router-link
                :to="{ name: 'System Settings' }"
                class="p-0 nav-link lh-1"
                :class="color ? color : 'text-body'"
                title="Settings"
              >
                <i
                  class="material-icons cursor-pointer"
                  style="font-size: 22px"
                >
                  settings
                </i>
              </router-link>
            </li>

            <!-- User Profile Dropdown -->
            <li class="nav-item dropdown d-flex align-items-center">
              <a
                href="#"
                class="p-0 nav-link lh-1 d-flex align-items-center"
                :class="[
                  color ? color : 'text-body',
                  showUserMenu ? 'show' : '',
                ]"
                id="userMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                @click="showUserMenu = !showUserMenu"
              >
                <!-- User Initials Avatar -->
                <div
                  class="d-flex align-items-center justify-content-center bg-gradient-primary text-white rounded-circle"
                  style="
                    width: 40px;
                    height: 40px;
                    font-weight: 600;
                    font-size: 14px;
                    cursor: pointer;
                  "
                >
                  {{ userInitials }}
                </div>
              </a>

              <!-- Dropdown Menu -->
              <ul
                class="dropdown-menu dropdown-menu-end px-2 py-3 me-sm-n4"
                :class="showUserMenu ? 'show' : ''"
                aria-labelledby="userMenuButton"
                style="min-width: 200px"
              >
                <!-- User Info Header -->
                <li class="mb-2 px-3">
                  <div class="d-flex flex-column">
                    <h6 class="mb-0 text-sm font-weight-bold text-dark">
                      {{ userName }}
                    </h6>
                    <p class="mb-0 text-xs text-secondary">
                      {{ userEmail }}
                    </p>
                  </div>
                </li>
                <li><hr class="dropdown-divider" /></li>

                <!-- Profile Link -->
                <li>
                  <router-link
                    :to="{ name: 'Profile' }"
                    class="dropdown-item border-radius-md d-flex align-items-center"
                    @click="showUserMenu = false"
                  >
                    <i
                      class="material-icons me-2 text-dark"
                      style="font-size: 20px"
                      >person</i
                    >
                    <span class="text-sm">My Profile</span>
                  </router-link>
                </li>

                <li><hr class="dropdown-divider" /></li>

                <!-- Logout Link -->
                <li>
                  <a
                    href="#"
                    @click.prevent="handleLogout"
                    class="dropdown-item border-radius-md d-flex align-items-center"
                  >
                    <i
                      class="material-icons me-2 text-danger"
                      style="font-size: 20px"
                      >logout</i
                    >
                    <span class="text-sm text-danger font-weight-bold"
                      >Logout</span
                    >
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Breadcrumbs from "../Breadcrumbs.vue";

export default {
  name: "navbar",
  data() {
    return {
      showUserMenu: false,
      userName: "",
      userEmail: "",
    };
  },
  props: ["minNav", "color"],
  created() {
    this.minNav;
    this.fetchUserData();
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),

    toggleSidebar() {
      this.navbarMinimize();
    },

    async fetchUserData() {
      const storedUser = localStorage.getItem("user");
      if (storedUser && storedUser !== "undefined" && storedUser !== "null") {
        try {
          const user = JSON.parse(storedUser);
          this.userName = user.full_name || "User";
          this.userEmail = user.email || "";
        } catch (error) {
          //console.error("Error parsing user data:", error);
          // Clear invalid data
          localStorage.removeItem("user");
        }
      }
    },

    handleLogout() {
      // Use Vuex auth store to logout
      this.$store.dispatch("auth/logout");

      // Close dropdown
      this.showUserMenu = false;

      // Redirect to sign-in page
      this.$router.push({ name: "SignIn" });
    },
  },
  components: {
    Breadcrumbs,
  },
  computed: {
    ...mapState(["isRTL", "isAbsolute"]),

    currentRouteName() {
      return this.$route.name;
    },

    userInitials() {
      // Extract initials from user name
      if (!this.userName) return "U";

      const names = this.userName.trim().split(" ");
      if (names.length === 1) {
        return names[0].charAt(0).toUpperCase();
      }
      return (
        names[0].charAt(0) + names[names.length - 1].charAt(0)
      ).toUpperCase();
    },
  },
};
</script>

<style scoped>
/* Smooth dropdown animation */
.dropdown-menu {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  transform-origin: top right;
}

.dropdown-menu.show {
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effects */
.dropdown-item:hover {
  background-color: #f8f9fa;
  transform: translateX(5px);
  transition: all 0.2s ease;
}

/* User avatar hover effect */
.bg-gradient-primary:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Settings icon hover */
.material-icons.cursor-pointer:hover {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}
</style>
